/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inviteMsg: {
      color: '#40404B',
      fontWeight: 500,
      marginTop: theme.spacing(1),
      textAlign: 'center',
      paddingLeft: '20px',
      paddingRight: '20px',
    },
    orgName: {
      color: theme.palette.primary.main,
      fontWeight: 500,
      marginTop: theme.spacing(1),
      textAlign: 'center',
    },
  })
);

export const InvitationLoadingMessage = () => {
  const classes = useStyles();
  return (
    <Typography component="div" className={classes.inviteMsg} variant="h4">
      <FormattedMessage
        id="app.org.invitation.accept.loading.label"
        defaultMessage="Verifying invitation."
      />
    </Typography>
  );
};

export const InvitationErrorMessage = () => {
  const classes = useStyles();
  return (
    <Typography component="div" className={classes.inviteMsg} variant="h4">
      <FormattedMessage
        id="app.org.invitation.accept.invalid.label"
        defaultMessage="Your invitation is invalid. Please verify the link and try again."
      />
    </Typography>
  );
};

export const InvitationVerifiedMessage = ({ orgName }: { orgName: string }) => {
  const classes = useStyles();
  return (
    <>
      <Typography component="div" className={classes.inviteMsg} variant="h4">
        <FormattedMessage
          id="app.org.invitation.accept.success.label"
          defaultMessage="You have been invited to the organization"
        />
      </Typography>
      <Typography component="div" className={classes.orgName} variant="h4">
        {orgName}
      </Typography>
    </>
  );
};
